import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.lunaclassicstation.com';
const DEFAULT_IMAGE = `${SITE_URL}/cosmos-station-mark.svg`;

const seoByPath = {
  '/': {
    title: 'Cosmos-Station | Cosmos Chain Dashboards',
    description:
      'Explore live Cosmos chain dashboards, validators, network activity, staking, governance, and available market data.',
    canonical: `${SITE_URL}/`,
  },
  '/classic-dashboard': {
    title: 'Terra Classic LUNC Dashboard | Cosmos-Station',
    description: 'Explore Terra Classic burns, market data, pools, governance proposals, and network health.',
    canonical: `${SITE_URL}/classic-dashboard`,
  },
  '/stats': {
    title: 'Cosmos Chain Stats | Cosmos-Station',
    description: 'Choose a Cosmos network and explore the live statistics available for that chain.',
    canonical: `${SITE_URL}/stats`,
  },
  '/services': {
    title: 'Cosmos Validators | Cosmos-Station',
    description:
      'Explore Cosmos validators with chain-specific uptime, staking, voting power, commission, delegators and governance details.',
    canonical: `${SITE_URL}/Services`,
  },
  '/valservices': {
    title: 'Cosmos Validator & Node Services | Cosmos-Station',
    description:
      'Validator maintenance, node infrastructure, RPC endpoints, and archive nodes for Cosmos networks with zero custody and owner control.',
    canonical: `${SITE_URL}/valservices`,
  },
};

const noIndexPrefixes = [
  '/admin',
  '/admin-panel',
  '/loggedin',
  '/validatorinfo',
  '/forgot-password',
  '/reset-password',
];

function setMeta(selector, attr, value) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement('meta');
    const name = selector.match(/meta\[name="([^"]+)"\]/)?.[1];
    const property = selector.match(/meta\[property="([^"]+)"\]/)?.[1];
    if (name) tag.setAttribute('name', name);
    if (property) tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute(attr, value);
}

function setCanonical(href) {
  let tag = document.head.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
}

function SEO() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const seo = seoByPath[path] || (path.startsWith('/stats/') ? {
      ...seoByPath['/stats'], canonical: `${SITE_URL}${path}`,
    } : seoByPath['/']);
    const shouldNoIndex = noIndexPrefixes.some((prefix) => path.startsWith(prefix));
    const robots = shouldNoIndex ? 'noindex, nofollow' : 'index, follow';

    document.title = seo.title;
    setCanonical(seo.canonical);

    setMeta('meta[name="description"]', 'content', seo.description);
    setMeta('meta[name="robots"]', 'content', robots);
    setMeta('meta[property="og:title"]', 'content', seo.title);
    setMeta('meta[property="og:description"]', 'content', seo.description);
    setMeta('meta[property="og:url"]', 'content', seo.canonical);
    setMeta('meta[property="og:image"]', 'content', DEFAULT_IMAGE);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[name="twitter:title"]', 'content', seo.title);
    setMeta('meta[name="twitter:description"]', 'content', seo.description);
    setMeta('meta[name="twitter:image"]', 'content', DEFAULT_IMAGE);
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
  }, [location.pathname]);

  return null;
}

export default SEO;
